var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.button, _vm.$style[("button_theme_" + _vm.modify)], ( _obj = {}, _obj[_vm.$style['button_is_disabled']] = _vm.disabled, _obj )],attrs:{"type":_vm.type || 'button',"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{class:_vm.$style['button__inner']},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }